<template>
  	<div class="stores" @click='topHide' style="height:100%">
		<div style="padding: 10px 0">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>课程管理</el-breadcrumb-item>
				<el-breadcrumb-item>导演课程列表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="hall-search-list">
			<span class="hall-search-name">教练名称:</span>
			<div class="topinput">
				<input type="text" placeholder="请输入教练名称" class="el-input__inner" v-model="nickname" @keyup="search" @keyup.enter="search_mine()"/>
				<ul class="nickNameul" v-if="fuzzyQueryShow">
					<li v-for="item in nicknameData" @click="nicknameitem(item.id,item.nickName)">{{item.nickName}}</li>
				</ul>
			</div>
			<span class="hall-search-name">课程时间:</span>
			<el-date-picker
	      		v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="课程开始日期"
	      		end-placeholder="课程结束日期"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker>
			<span class="hall-search-line"></span>
			<el-button type="primary" @click="search_mine()">搜索</el-button>
		</div>
		<div style="padding:10px 0">
            <el-tabs v-model="activeName" @tab-click="topnav">
                <el-tab-pane label="全部" name="-1"></el-tab-pane>
                <el-tab-pane v-for="(item,index) in selData" :key="index" :label="item.name" :name="index+''"></el-tab-pane>
             </el-tabs>
        </div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData"  style="width: 100%" >
			        <el-table-column prop="id" label="ID"></el-table-column>
			        <el-table-column prop="coachName" label="课程教练" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="name"  label="课程名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="sportKindName"  label="运动类型名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="beginTime"  :formatter="this.global.dateFormat" label="课程开始时间" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="endTime" :formatter="this.global.dateFormat" label="课程结束时间" show-overflow-tooltip></el-table-column>
			       <el-table-column label="操作" width="120" align="center">
						<template slot-scope="scope">
							<el-button v-has="'course_type_update'"
									@click="edit(scope.row.id)"
									type="text"
									size="small"
									icon="el-icon-s-order">编辑</el-button>
						</template>
					</el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>
	    <!-- 添加修改弹框 -->
	    <el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="140px">
		        <el-form-item label="课程名字" prop="name">
		          	<el-input v-model="ruleForm.name" placeholder="请输入课程名字" style="width: 80%;" :disabled="is_director"></el-input>
		        </el-form-item>
                <el-form-item label="课程背景色" prop="backcolor">
                  <el-radio-group v-model="ruleForm.backcolor" :disabled="is_director">
                    <el-radio :label="1">浅色</el-radio>
                    <el-radio :label="2">深色</el-radio>
                  </el-radio-group>
		        </el-form-item>
		        <!-- <el-form-item label="选择门店" prop="storesId">
		          	<el-select v-model="ruleForm.storeName" placeholder="请选择门店" style="width: 80%;" @change="rulestoresId" :disabled="is_director">
		            	<el-option v-for="item in tableData2" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
		        </el-form-item> -->
	        	<!-- 选择用户 -->
	        	<el-form-item label="请选择教练" prop="coachIds" class="selectUser" >
	          		<!-- <i class="el-icon-edit" :disabled="true"></i>
	          		<label @click="selCoachesDialog()">{{ruleForm.coachName}}</label> -->
                    <div style="padding:4px 0 10px 0;">
                        <el-tag style="margin:6px 6px 0 0;" v-for="(tag) in coachesChoice" :key="tag.id">{{tag.coachName}}</el-tag>
                    </div> 
	        	</el-form-item>
		        <el-form-item label="课程标签">
                  <el-checkbox-group v-model="courseTagVosList" :disabled="is_director">
                        <el-checkbox :label="item.id" v-for="item in courseTagVosData" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
		        </el-form-item>
		        <el-form-item label="运动类型" prop="sportsKindId">
		          	<el-select v-model="ruleForm.sportsKindId" placeholder="请选择运动类型" style="width: 80%;" :disabled="is_director">
		            	<el-option v-for="item in selData" :key="item.id" :label="item.name" :value="item.id" >{{item.name}}</el-option>
		          </el-select>
		        </el-form-item>
		        <el-form-item label="课程类型">
		          	<el-select v-model="ruleForm.kindId" placeholder="请选择" style="width: 80%;" :disabled="is_director">
		            	<el-option v-for="item in kindData" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
		        </el-form-item>

		        <!-- <input type="hidden" v-model="ruleForm.courseIntensityId">
		        <el-form-item label="课程强度" prop="courseIntensityId">
		          	<el-select v-model="ruleForm.star" placeholder="请选择" style="width: 80%;" @change="ruleIntensityId" :disabled="is_director">
		            	<el-option v-for="item in intensityData" :key="item.id" :label="item.star" :value="item.id">{{item.star}}</el-option>
		          	</el-select>
		        </el-form-item> -->

	        	<el-form-item label="课程时间" prop="beginTime">
	          		<el-date-picker v-model="ruleForm.beginTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 80%;" :disabled="is_director"></el-date-picker>
	        	</el-form-item>
	        	<el-form-item label="课程时长(分钟)" prop="durationId"> 
                    <el-radio-group v-model="ruleForm.durationId" :disabled="is_director">
                        <el-radio :label="item.id" :key="item.id" v-for="item in courseTimeData">{{item.duration}}分钟</el-radio>
                    </el-radio-group>
	        	</el-form-item>

	        	<!-- <el-form-item label="可见度">
				    <el-checkbox-group v-model="ruleForm.visibility">
				      <el-checkbox label="指定用户可见" name="visibility"></el-checkbox>
				    </el-checkbox-group>
				</el-form-item> -->

	        	<!-- 封面图片 -->
	        	<el-form-item label="直播背景图片" prop="liveBackgroundUrl">
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(1)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.liveBackgroundUrl" fit="fill" v-if="ruleForm.liveBackgroundUrl"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请上传图片</div>
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：650x348</p>
		        </el-form-item>
                <!-- 封面图片 -->
	        	<el-form-item label="直播封面图片" prop="liveCoverUrl">
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(2)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.liveCoverUrl" fit="fill" v-if="ruleForm.liveCoverUrl"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请上传图片</div>
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：304x348</p>
		        </el-form-item>
                <!-- 封面图片 -->
	        	<el-form-item label="点播封面图片" prop="introPic">
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(3)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.introPic" fit="fill" v-if="ruleForm.introPic"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请上传图片</div>
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：304x3488</p>
		        </el-form-item>
	        	<el-form-item label="课程介绍" prop="introText">
	          		<el-input type="textarea" v-model="ruleForm.introText" style="width:80%" :rows="4" ></el-input>
	        	</el-form-item>
		        <!-- <el-form-item label="课程介绍_en" prop="introTextEn">
		          	<el-input type="textarea" v-model="ruleForm.introTextEn" style="width:80%" :rows="4" :disabled="is_director"></el-input>
		        </el-form-item> -->
		        <!-- <el-form-item label="直播地址(高清)" prop="liveVideo" class="">
		          	<label style="width: 80%;">{{ruleForm.liveVideo}}</label>
		        </el-form-item> -->
	        	<el-form-item label="源视频(高清)地址" class="video-upload">
	          		<el-input v-model="ruleForm.originalVideoHigh"  placeholder style="width: 80%;"></el-input>
	        	</el-form-item>
	        	<el-form-item label="源视频(标清)地址" class="video-upload">
		          	<el-input v-model="ruleForm.originalVideoStandard"  placeholder style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="源视频(低清)地址" class="video-upload">
	                <el-input v-model="ruleForm.originalVideoLow" placeholder></el-input>
	            </el-form-item>
		        <el-form-item label prop="id" v-show="isShow">
		          	<el-input v-model="ruleForm.id" placeholder></el-input>
		        </el-form-item>
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSave()">确 定</el-button>	
	      	</span>
	    </el-dialog>
		<gallery-model :active="galleryActive" :choice-img="choiceImg" :dialog.sync="galleryModelShow"></gallery-model>
  	</div>
</template>  
<script>
import GalleryModel from '@/components/GalleryModel';
export default {
  	components: {GalleryModel},
  	mounted() {
  		this.userId=localStorage.getItem("userId")
    	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
    	this.sportsKind()
  	},
  	data() {
    	return {
			activeName:'-1',
			galleryActive:'1',
			galleryModelShow:false,
    		cur:-1,
    		userId:'',
    		paramcoach:{
    			pageNum: 1,
        		limit: 10
    		},//选择教练参数配置
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
      		tmpFiles: process.env.API_ROOT + "/tmpFiles",
      		selData: [], //选择运动种类
      		tableData2: [], //选择门店
      		tableData: [], //初始化表格
      		pageNum: 1,
      		limit: 10,
      		totalPage: 10,
			courseTagVosData:[],
			courseTagVosList:[],
      		coachesData: [], //教练列表
      		pageNum2: 1,
      		limit2: 5,
      		totalPage2: 10,
			coachesChoice:[],
      		kindData: [], //课程类型列表
      		courseTimeData: [], //课程时长
      		currentRow: "",
      		ruleForm: {
		        backcolor: 1,//背景色 背景色 1：浅色 2：深色
                beginTime: '',
                coachIds:'',
                courseTagVos: [],
                durationId:1,
                introPic: '',
                introText: '',
                sportsKindId: '',
                liveBackgroundUrl:'',
                liveCoverUrl:'',
                id: '',
                kindId: '',
                originalVideoHigh: '',//高清视频
                originalVideoStandard: '',//标清视频
                originalVideoLow: '',//低清视频
      		},
	      	videoFlag: false, //刚开始的时候显示为flase
	      	videoUploadPercent: "0%", //进度条刚开始的时候为0%
	      	Video: "",
	      	videoFlag2: false,
	      	videoUploadPercent2: "0%",
	      	ruleForms: {
		        sportsKindId: [{ required: true, message: "请选择运动类型",trigger: 'change' }],
		        name: [{ required: true, message: "请输入课程名字" }],
		        nameEn: [{ required: true, message: "请输入课程名字_en" }],
		        durationId:[{ required: true, message: "请选择课程时长",trigger: 'change' }],
		        coachId:[{ required: true, message: "请选择教练",trigger: 'change' }],
		        beginTime:[{ required: true, message: "请选择课程时间",trigger: 'change' }],
	      	},
	      	dialogVisible: false,
	      	isShow: false,
	      	//课程阶段列表
	      	coursePhaseData: [],
	      	sportsKindId: 0,
	      	kindIdisShow:false,//课程类型
	      	stageData:'',//阶段数据
	      	intensityData:[],// 课程强度
	      	nicknameData:[],
	      	nickname:'',
	      	fuzzyQueryShow:false,
	      	coachId:'',//教练ID
	      	timeVal:'',
	      	returnCourse:'',
	      	is_director:true,//是否是导演角色
	    };
  	},
  	methods: {
		openImgMode(flag){
            this.galleryModelShow=true;
            this.galleryActive=flag+''
        },
        choiceImg(e){
            if(this.galleryActive == 1){
                this.ruleForm.liveBackgroundUrl=e.coverUrl;
            }else if(this.galleryActive == 2){
                this.ruleForm.liveCoverUrl=e.coverUrl;
            }else if(this.galleryActive == 3){
                this.ruleForm.introPic=e.coverUrl;
            }
        },
	    //初始化表格数据
	    page(pageNum,limit,userId,sportsKindId,coachId,nickname,beginTime,endTime){
	    	var params=this.calculate();
	    	this.$get("/course", params)
	        .then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;

	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	        .catch(() => {
	         	console.log();
	        });
	    },
	    calculate(){
	    	var dataFer = {
	    		pageNum:this.pageNum,
	    		limit:this.limit,
	    		userId:this.userId,
	        	sportsKindId:this.sportsKindId,
	        	nickname:this.nickname
		    }
		    if(this.coachId){
		    	dataFer.coachId=this.coachId
		    }
		    // if(this.nickname){
		    // 	dataFer.nickname=this.nickname
		    // }
		    if(this.timeVal){	
		    	dataFer.beginTime=this.$moment(this.timeVal[0]).valueOf();
		    	dataFer.endTime=this.$moment(this.timeVal[1]).valueOf();
		    }
		    return dataFer;
	    },
	    search(){//模糊查询
	    	this.coachId='';
	  		if(this.nickname){
	  			var params = {
		        	pageNum: 1,
		        	limit: this.limit,
		        	nickname:this.nickname
		      	};
	  			this.$get("/coaches/nickname", params)
		        .then(res => {
		        	console.log(res)
		          	if (res.code == 0) {
		            	this.nicknameData=res.data.list;
		            	if(res.data.list.length>0){
		            		this.fuzzyQueryShow=true;
		            	}
		          	} else {
			            this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
	  		}else{
	  			this.nicknameData=[];
	  			this.fuzzyQueryShow=false;
	  		}
	  	},
	  	nicknameitem(id,name){
	  		this.coachId=id;
	  		this.nickname=name;
	  		this.fuzzyQueryShow=false;
	  	},
	  	search_mine(){
	  		this.pageNum=1;
	  		this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	  	},
	  	topHide(){
	  		//this.coachId='';
	  		this.fuzzyQueryShow=false;
	  	},
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	      	//this.init();
	    },
	    //当前教练页数
	    handleCurrentChangePage2(val) {
	      	this.paramcoach.pageNum = val;
	      	this.selCoachesData();
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.$refs.ruleForm.clearValidate();
		      	this.ruleForm={
			        name: "",
			        nameEn: "",
			        storesId: "",
			        coachId: "",
			        coachName: "点击选择",
			        introPic: "",
			        introText: "",
			        introTextEn: "",
			        liveVideo:
			          "rtmp://play.xqiaotv.com/live/XQIAO_HD_test?auth_key=1593477663-0-0-39228c71ed69b78b916f579c947a7ec5",
			        sportsKindId: "",
			        id: "",
			        kindId: "",
			        beginTime: "",
			        endTime: "",
			        originalVideo: "",
			        editedVideo: ""
		      	}
	      	}
	      	done()
	    },
	    //选择需要修改的权限
	    handleCurrentChange(val) {
	      	if (val) {
		        this.currentRow = val.id;
		        //this.sportsKindId = val.sportsKindId;
		        this.returnCourse=val.returnCourse
	      	}
	    },
	    //点击选择教练
	    selCoachesDialog() {
	    	if(this.is_director==false){
	    		this.dialogVisible2 = true;
	    	}else{
	    		this.$message({
	              	message: '此身份不可编辑',
	              	type: "warning"
	            });
	    	}	
	    },

	    //选择门店
	    selectStores() {
	      	var params = {
	        	pageNum: 1,
	        	limit: 20
	      	};
	      	this.$get("/stores", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
	            	this.tableData2 = res.data.list;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
	          	}
	        })
	        .catch(() => {
	          console.log();
	        });
	    },
	    rulestoresId(val){//修改门店
	    	this.ruleForm.storesId=val
	    },
	    //选择教练
	    selCoachesData(choiceList=[]) {
	      	this.$get("/coaches", {
				pageNum:1,
				limit:1000
			})
	        .then(res => {
	          	if (res.code == 0) {
					let list=Array.isArray(res.data.list)?res.data.list:[];
					if(choiceList.length>0){
						let arr=[];
						list.forEach(item=>{
							choiceList.forEach(val => {
								if(item.id == val){
									arr.push(item)
								}
							});
						})
						this.coachesChoice=arr;
					}
		            this.coachesData = list;
		            this.totalPage2 = res.data.total;
	          	} else {
	            	this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
	          	}
	        })
	        .catch(() => {
	          console.log();
	        });
	    },
	    //选择运动种类
	    sportsKind() {
	      	this.$get("/course/sportsKind", {})
	        .then(res => {
	          	console.log(res)
	          	if (res.code == 0) {
					let list=Array.isArray(res.data)?res.data:[];
	            	this.selData = list.map(item=>item.id=Number(item.id));
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
	    },
	    rulesportKindId(val){//修改运动类型
	      	this.ruleForm.sportsKindId=val;
	      	if(val>=0){
	      		this.selCourseKind('change');
	      	}
	    },
	    //选择课程类型
	    selCourseKind(e) {
		    this.$get("/course/courseKind", {
		        sportsKindId: this.ruleForm.sportsKindId
		    })
	        .then(res => {
	        	console.log('课程类型')
	        	console.log(res)
	          	if (res.code == 0) {
	            	this.kindData = res.data;
	            	if(res.data.length){
	            		if(e=='change'){
	            			this.ruleForm.courseKindName=res.data[0].name
	            			this.ruleForm.kindId=res.data[0].id
	            		}
	            		this.kindIdisShow=true
	            	}else{
	            		this.kindIdisShow=false
	            	}
	          	} else {
		            this.$message({
		              message: res.message,
		              type: "warning"
		            });
	            	return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
	    },
	    rulekindId(val){
	    	this.ruleForm.kindId=val;
	    },
	    //课程时长
	    courseTime() {
	      	this.$get("/course/courseDuration", {})
	        .then(res => {
	          if (res.code == 0) {
	            this.courseTimeData = res.data;
	          } else {
	            this.$message({
	              message: res.message,
	              type: "warning"
	            });
	            return false;
	          }
	        })
	        .catch(() => {
	          console.log();
	        });
	    },
	    //课程强度
	    intensity(){
	    	this.$get("/course/queryCourseIntensity", {})
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
	            	this.intensityData=res.data
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	        .catch(() => {
	          console.log();
	        });
	    },
	    ruleIntensityId(val){//修改课程强度
	    	this.ruleForm.courseIntensityId=val;
	    },
	    ruledurationId(val){//修改课程时长
	    	this.ruleForm.durationId=val;
	    },
	    topnav(){
	    	this.pageNum=1;
			let index = Number(this.activeName);
			this.sportsKindId =
				index === -1
				? 0
				: Array.isArray(this.selData) && this.selData.length > 0
				? this.selData[index].id
				: 0;
			this.cur = index;
 			this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
 			//this.init();
 		},
	    edit(id) {
	      	this.sportsKind();
	      	this.courseTime();
	      	this.intensity();//课程强度
	      	this.$get("/course/queryCourseDetailById", {id})
	          	.then(res => {
	            	if (res.code == 0) {
	              		this.dialogVisible = true;
						res.data.beginTime=this.$_.isNumber(res.data.beginTime)?this.$moment(res.data.beginTime).format("YYYY-MM-DD HH:mm:ss"):'';
                        this.courseTagVosList=Array.isArray(res.data.courseTagVos) && res.data.courseTagVos.length>0?res.data.courseTagVos.map(item=>item.id):[];
						let coachIds=this.$_.isString(res.data.coachId)?(Array.isArray(res.data.coachId.split(','))?res.data.coachId.split(','):[]):[];
		              	this.$nextTick(function() {
		              		this.ruleForm = res.data;
		              		if(res.data.sportsKindId>=0){
		              			console.log('进来')
					      		this.selCourseKind();
					      	}
		              	});
						this.selCoachesData(coachIds);
	            	}
	          	})
	          	.catch(() => {});
	    },
	    onSave() {
	      	//var that = this;
	      	//通过表单id判断，如果id有值为修改，否则是添加
	      	if (this.currentRow) {
		        console.log("修改");
		        this.$refs.ruleForm.validate(valid => {
		          	if (valid) {
			            this.loading = true;
			            this.$axios.put("/course/" + this.ruleForm.id,JSON.stringify(this.ruleForm))
			            .then(res => {
			                this.loading = false;
			                if (res.data.code == 0) {
			                  	this.$message({
			                    	message: "修改成功",
			                    	type: "success"
			                  	});
			                  	this.$refs.ruleForm.resetFields();
			                  	this.$refs.ruleForm.clearValidate();
			                  	this.dialogVisible = false;
			                  	this.common();
			                } else {
			                  	this.$message({
			                    	message: res.data.message,
			                    	type: "warning"
			                  	});
			                  	return false;
			                }
			            })
			            .catch(() => {
			                this.loading = false;
			            });
		          	} else {
		            	console.log("error submit!!");
		            	return false;
		          	}
		        });
	      	} else {
		        console.log("添加");
		        console.log(this.ruleForm)
		        this.$refs.ruleForm.validate(valid => {
		          	if (valid) {
			            this.loading = true;
			            this.$post("/course", JSON.stringify(this.ruleForm))
			            .then(res => {
			                this.loading = false;
			                if (res.code == 0) {
			                  	this.$message({
			                    	message: "添加成功",
			                    	type: "success"
			                  	});
			                  	this.ruleForm.userName = "点击选择用户";
			                  	this.$refs.ruleForm.resetFields();
			                  	this.dialogVisible = false;
			                  	this.common();
			                } else {
			                  	this.$message({
			                    	message: res.message,
			                    	type: "warning"
			                  	});
			                  	return false;
			                }
			            })
			            .catch(() => {
			                this.loading = false;
			            });
		          	} else {
		            	console.log("error submit!!");
		            	return false;
		          	}
		        });
	      	}
	    },
	    common(){
	    	this.currentRow='';
          	this.pageNum=1;
          	this.cur=-1;
          	this.coachId='';
          	this.nickname='';
          	this.timeVal='';
          	this.sportsKindId=0;
          	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	    },
	    //选择图片成功
	    handleAvatarSuccess(res, file) {
	      	console.log(res);
	      	this.ruleForm.introPic = res.data.url;
	    },
	    beforeAvatarUpload(file) {
	      	const isJPG = file.type === "image/jpeg";
	      	const isLt2M = file.size / 1024 < 100;
	      	if (!isJPG) {
	      	  	this.$message.error('上传封面只能是 JPG 格式');
	      	  	return false
	      	}
	      	if (!isLt2M) {
	        	this.$message.error("上传封面大小不能超过 100kb!");
	      	}
	      	return isJPG && isLt2M;
	    },
	    //视频
	    beforeUploadVideo(file) {
	      	//视频上传之前判断他的大小
	      	const isLt10M = file.size / 1024 / 1024 < 2000;
	      	if (!isLt10M) {
	        	this.$message.error("上传视频大小不能超过2000MB哦!");
	        	return false;
	      	}
	    },
	    uploadVideoProcess(event, file, fileList) {
	      	//视频上传的时候获取上传进度传给进度条
	      	this.videoFlag = true;
	      	this.videoUploadPercent = parseInt(file.percentage);
	      	console.log(this.videoUploadPercent);
	    },
	    handleVideoSuccess(res, file) {
	      	//视频上传成功之后返回视频地址
	      	this.videoFlag = false;
	      	this.videoUploadPercent = 0;
	      	console.log(res);
	      	this.ruleForm.originalVideo = res.data.url;
	    },
	    // 视频2
	    beforeUploadVideo2(file) {
	      	//视频上传之前判断他的大小
	      	const isLt10M = file.size / 1024 / 1024 < 2000;
	      	if (!isLt10M) {
	        	this.$message.error("上传视频大小不能超过2000MB哦!");
	        	return false;
	      	}
	    },
	    uploadVideoProcess2(event, file, fileList) {
	      	//视频上传的时候获取上传进度传给进度条
	      	this.videoFlag2 = true;
	      	this.videoUploadPercent2 = parseInt(file.percentage);
	      	console.log(this.videoUploadPercent2);
	    },
	    handleVideoSuccess2(res, file) {
	      	//视频上传成功之后返回视频地址
	      	this.videoFlag2 = false;
	      	this.videoUploadPercent2 = 0;
	      	console.log(res);
	      	this.ruleForm.editedVideo = res.data.url;
	    },
  	}
};
</script>

<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
.selectUser {
  color: #409eff;
}
.selectUser label,
.selectUser i {
  	font-size: 12px;
}

::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.searchBtn .el-range-editor.el-input__inner{
	margin: 0 15px
}
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
.nickNameul{
	position: absolute;
	background: #fff;
	width: 100%;
	padding: 10px;
	font-size: 13px;
	line-height: 25px;
	border: 1px solid #DCDFE6;
	border-top: none
}
.nickNameul li{
	color: #666;
	cursor: pointer;
}
.nickNameul li:hover{
	color: #409EFF
}
</style>



// WEBPACK FOOTER //
// src/views/coursesList/directorCourseList.vue